import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Button from 'material-ui/Button';
import {FormControlLabel} from 'material-ui/Form';
import logo from 'assets/Images/H-Logo.png';
import {post} from 'engine/dataServices';
import {Redirect, Route} from 'react-router-dom';
import {NotificationManager} from 'react-notifications';
import Validator from 'components/Validator';
import $ from 'jquery';
import Loading from 'app/loading';

class Login2 extends Component {

    constructor(props) {
        super(props);


        this.state = {
            userName: '',
            password: '',
            rememberMe: false,
            loading: false
        };

        this.validator = Validator();

        this.handleLoading(true);
    }

    componentDidMount() {
        if ($('.warm-canvas').length) {
            $('.warm-canvas').glassyWorms({
                colors: ['#fff', '#c2c2c2'],
                useStyles: true,
                numParticles: 450,
                tailLength: 20,
                maxForce: 8,
                friction: 0.75,
                gravity: 9.81,
                interval: 3
                // colors: ['#000'],
                // element: $('<canvas class="worms"></canvas>')[0]
            });
        }
    }

    handleLoading = (status) => {
        this.setState({loading: status})
    }

    handleRememberSelect = (event, checked) => {
        if (checked) {
            this.setState({rememberMe: true});
            return;
        }
        this.setState({rememberMe: false});
    };

    async btn() {
        if (this.validator.allValid()) {
            this.handleLoading(true);
            let data = {
                Mobile: this.state.userName,
                Password: this.state.password,
                RememberMe: this.state.rememberMe
            };


            let response = await post('User/Login/', data);
            if (response.status === 200) {
                var resData = await response.json();
                localStorage.setItem('userToken', resData.Token);
                localStorage.setItem('userName', resData.Mobile);
                localStorage.setItem('userImage', resData.Setting.UserImage);
                window.location = '/';
            }

            this.handleLoading(false);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }

        //this.props.handleLoading(true);


        /*switch (response.status) {
            case 200:
                var resData = await response.json();
                localStorage.setItem('userToken', resData.Token);
                localStorage.setItem('userName', resData.Mobile);

                window.location= "/";
                //window.location.reload();
                break;
            case 405:
                NotificationManager.error('دسترسی ورود به مدیریت را ندارید از طریق فرم ثبت نام اقدام نمایید.', 'دسترسی محدود');
                break;
            case 406:
                NotificationManager.error('نام کاربری یا کلمه عبور صحیح نمی باشد.', 'دسترسی محدود');
                break;
            case 500:
                NotificationManager.error('خطا در عملیات', 'خطا');
                break;
            default:
                this.props.handleLoading(false);
                break;*/
    }


    render() {
        return (
            <div
                className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3 warm-canvas">
                {this.state.loading && <Loading/>}
                <div className="login-content">
                    <div className="login-header mb-4">
                        <a className="app-logo" href="#/" title="Jambo">
                            <img src={logo} alt="Apall" title="Apall"/>
                        </a>
                    </div>

                    <div className="login-form">
                        <form>
                            <fieldset>
                                <TextField
                                    id="required"
                                    label="تلفن همراه"
                                    fullWidth
                                    defaultValue=""
                                    margin="normal"
                                    className="mt-1"
                                    onChange={(val) => {
                                        this.setState({userName: val.target.value});
                                    }}
                                />
                                {this.validator.message('تلفن همراه', this.state.userName, 'required|mobile')}
                                <TextField
                                    type="password"
                                    id="required"
                                    label="کلمه عبور"
                                    fullWidth
                                    defaultValue=""
                                    margin="normal"
                                    className="mt-1"
                                    onChange={(val) => {
                                        this.setState({password: val.target.value});
                                    }}
                                />
                                {this.validator.message('کلمه عبور', this.state.password, 'required')}
                                <div className="mt-1 mb-2 d-flex justify-content-between align-items-center">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color="secondary"
                                                value="gilad"
                                                onChange={this.handleRememberSelect.bind(this)}
                                            />
                                        }
                                        label="مرا به یاد داشته باشید."
                                    />

                                    <div>
                                        {/*<a className="text-primary" href="#/app/app-module/forgot-password-2"
                                           title="Reset Password">فراموشی کلمه عبور</a>*/}
                                    </div>
                                </div>

                                <div className="mt-1 mb-2 d-flex justify-content-between align-items-center">
                                    <div>
                                        <a className="text-primary" href="#/app/accounthandler/Register"
                                           title="Reset Password">ثبت نام و پیوستن به تولیتون</a>
                                    </div>

                                    <Button variant="raised" onClick={this.btn.bind(this)}
                                            className="jr-btn btn-yellow-background font-weight-bold">ورود</Button>
                                </div>

                            </fieldset>
                        </form>
                    </div>
                </div>


            </div>
        );
    }
}

export default Login2;

const styles = {
    root: {
        '&$checked': {
            color: '#1565c0',
        }
    },
    checked: {}
}



// WEBPACK FOOTER //
// ./app/routes/appModule/routes/login/Login2.js